export const siteSettings = {
  name: "Option FX Stock Profit",
  link: "https://optfxstock.pro",
  email: "support@optfxstock.pro",
  appLink: "https://app.optfxstock.pro",
};
